import React from 'react';
import Modal from 'react-modal';
import { CheckCircle, Mail, ArrowRight, Sparkles } from 'lucide-react';
import { Button } from '../ui/Button';
import { siteConfig } from '../../config/site';
import { trackEvent, FunnelSteps } from '../../lib/analytics';
import ambientacionImg from '../../assets/Ambientación ejemplo.png';

Modal.setAppElement('#root');

export function SuccessBridgeModal({ isOpen, onClose, email }) {
  const appUrl = siteConfig.urls.app;

  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={onClose}
      shouldCloseOnOverlayClick={false}
      className="mx-auto mt-8 max-h-[90vh] w-[95%] max-w-lg overflow-y-auto rounded-2xl bg-white p-0 outline-none md:mt-16"
      overlayClassName="fixed inset-0 z-[10000] bg-black/60 backdrop-blur-sm flex items-start justify-center p-4"
    >
      <div className="p-6 md:p-8">
        <div className="mx-auto mb-4 flex h-16 w-16 items-center justify-center rounded-full bg-brand-accent/20">
          <CheckCircle className="h-8 w-8 text-brand-accent" />
        </div>

        <h2 className="text-center font-display text-2xl font-bold text-brand-dark">
          Generando tu reporte de ambientación
        </h2>
        <p className="mt-3 text-center text-sm text-brand-earth">
          Tu análisis de productividad está en proceso. Lo vas a recibir en{' '}
          <strong className="text-brand-dark">{email}</strong> en los próximos minutos.
        </p>

        <div className="mt-6 overflow-hidden rounded-xl border border-brand-dark/10 shadow-card">
          <div className="flex items-center gap-2 border-b border-brand-dark/5 bg-surface-muted px-3 py-2">
            <Sparkles className="h-4 w-4 text-brand-accent" />
            <span className="text-xs font-medium text-brand-earth">Vista previa del reporte</span>
          </div>
          <img src={ambientacionImg} alt="Ejemplo de reporte" className="w-full object-cover" />
        </div>

        <div className="mt-6 space-y-3 rounded-xl bg-surface-muted p-4">
          <p className="text-sm font-semibold text-brand-dark">¿Qué podés hacer ahora?</p>
          <ul className="space-y-2 text-sm text-brand-earth">
            <li className="flex items-start gap-2">
              <Mail className="mt-0.5 h-4 w-4 shrink-0 text-brand-accent" />
              Revisá tu email (incluido spam) para el PDF con mapas de ambientes
            </li>
            <li className="flex items-start gap-2">
              <ArrowRight className="mt-0.5 h-4 w-4 shrink-0 text-brand-accent" />
              Ingresá a la plataforma para prescribir y exportar KML
            </li>
          </ul>
        </div>

        <div className="mt-6 flex flex-col gap-3">
          <Button
            href={appUrl}
            size="lg"
            className="w-full"
            onClick={() => trackEvent(FunnelSteps.SIGNUP_CTA_CLICKED, { source: 'success_modal' })}
            data-cta="success-signup"
          >
            Explorar la plataforma
          </Button>
          <Button
            href={siteConfig.urls.demo}
            variant="outline"
            className="w-full"
            onClick={() => trackEvent(FunnelSteps.DEMO_CTA_CLICKED, { source: 'success_modal' })}
            data-cta="success-demo"
          >
            Solicitar demo
          </Button>
          <button
            type="button"
            onClick={onClose}
            className="text-sm text-brand-earth underline-offset-4 hover:underline"
          >
            Cerrar y ambientar otro lote
          </button>
        </div>
      </div>
    </Modal>
  );
}
